/**
 * Enhanced Filter System with Shopify Built-in Pagination Support
 * This file extends theme.filter to work with Shopify's page parameter
 */

(function () {
    'use strict';

    // Store original methods
    var originalInit = theme.filter.init;
    var originalGet = theme.filter.get;
    var originalRun = theme.filter.run;
    var originalComplete = theme.filter.complete;
    var original_getFilterUrl = theme.filter._getFilterUrl;
    var original_paginate = theme.filter._paginate;

    // Add pagination metadata storage
    theme.filter.pagination = {
        current_page: 1,
        total_pages: 1,
        total_products: 0,
        page_size: 21
    };

    /**
     * Override init to use 'page' parameter instead of 'cp'
     */
    theme.filter.init = function () {
        theme.debugging && console.info("%c[Sureify Filters] ----- Initialising (Enhanced)", "color: #5fb8ff");

        $(window).width() > 1023 && (this.productLimit = 21, this.productsVisible = 21);
        this.ajaxContainer = $("[data-product-ajax]");
        this.filterContainer = $("[data-product-filter]:visible");
        this.loadingContainer = $("[data-product-faux]");
        this.intersectContainer = $("#intersect");
        this.noResultsContainer = $("[data-product-ajax-empty]");
        this.form = $(this.formNamespace);
        this.collection = this.form.data("collection");
        this.sortBy = $("[data-sort-by]").val();
        this.addListeners();

        // Use 'page' parameter instead of 'cp'
        var pageParam = new URLSearchParams(window.location.search).get("page");
        if (pageParam && pageParam > 1) {
            this.pagination.current_page = parseInt(pageParam);
        }

        this.get();
        this.firstRun = !1;
    };

    /**
     * Override get to handle pagination metadata from response
     */
    theme.filter.get = function (t) {
        theme.debugging && console.info("%c[Sureify Filters] ----- Get Products (Enhanced)", "color: #b386df");

        var e = this._getFilterUrl(t);
        this.loading();

        $.ajax({
            url: e,
            success: function (t) {
                t = JSON.parse(t);
                theme.filter.products = t.products;
                theme.filter.html = t.filter;

                // Store pagination metadata
                if (t.pagination) {
                    theme.filter.pagination = t.pagination;
                }

                theme.filter.run(!1);
                theme.filter.filterHtml();
                theme.filter.updatePaginationDisplay();
            },
            error: function (t, e) {
                alert("Error loading products");
            }
        });
    };

    /**
     * Override run to display all products (no client-side slicing)
     */
    theme.filter.run = function (t) {
        if (t || (theme.filter.ajaxContainer.empty(), theme.filter.promoRan = !1),
            0 == theme.filter.products.length) {
            return this.noResults(), !1;
        }

        var e;
        // Display all products from server response (already paginated)
        $.each(theme.filter.products, function (t, i) {
            e = theme.filter.template("product", i, t);
            theme.filter.ajaxContainer.append(e);

            // Handle promo insertion
            if (!theme.filter.promoRan &&
                t == theme.filter.ajaxContainer.data("promo-index") - 1) {
                e = theme.filter.template("promo", theme.product_promo_grid, t);
                theme.filter.ajaxContainer.append(e);
                theme.filter.promoRan = !0;
            }
        });

        theme.variants.init(!0);
        this.complete();
        t && (theme.filter.paginating = !1);
    };

    /**
     * Override complete to update pagination display
     */
    theme.filter.complete = function () {
        this.ajaxContainer.removeClass("invisible opacity-0");
        this.loadingContainer.addClass("invisible opacity-0");
        this.ajaxContainer.removeAttr("style");
        this.filterContainer.removeClass("opacity-20");

        var t = this.ajaxContainer.find("[data-product-box]").length;
        $("[data-product-count]").text(t).parent().removeClass("hidden");

        // Show/hide pagination based on total pages
        if (theme.filter.pagination.total_pages > 1) {
            $("[data-load-more]").removeClass("hidden");
        } else {
            $("[data-load-more]").addClass("hidden");
        }

        theme.filter.paginating || window.scrollTo({
            top: 0,
            behavior: "smooth"
        });

        setTimeout(function () {
            theme.filter._promoHeight();
        }, 1e3);
    };

    /**
     * Override _getFilterUrl to use 'page' parameter
     */
    theme.filter._getFilterUrl = function (t) {
        var e = window.location.search;
        t && (e = t);
        var i = new URLSearchParams(e);

        theme.filter.params && !t && (i = new URLSearchParams(theme.filter.params));

        i.append("view", theme.filter.liquidNamespace);
        i.get("sort_by") || i.append("sort_by", theme.filter.sortBy);

        // Handle price filters
        var r = i.get("filter.v.price.gte");
        "string" == typeof r && 0 === r.length && i.delete("filter.v.price.gte");
        var a = i.get("filter.v.price.lte");
        "string" == typeof a && 0 === a.length && i.delete("filter.v.price.lte");

        // Remove old 'cp' parameter if present
        i.delete("cp");

        var o = i.toString();
        theme.filter.firstRun || theme.filter._updateHistoryState(i);

        return theme.filter.collection + "?" + o;
    };

    /**
     * New method: Navigate to specific page
     */
    theme.filter.goToPage = function (pageNumber) {
        var url = new URL(window.location.href);
        var params = new URLSearchParams(url.search);

        if (pageNumber > 1) {
            params.set('page', pageNumber);
        } else {
            params.delete('page');
        }

        // Preserve filters and sorting
        var newUrl = url.pathname + '?' + params.toString();
        window.location.href = newUrl;
    };

    /**
     * New method: Update pagination display elements
     */
    theme.filter.updatePaginationDisplay = function () {
        var pagination = theme.filter.pagination;

        // Update total product count
        if ($('.fb_product_count').length > 0) {
            $('.fb_product_count').text(pagination.total_products);
        }

        // Update current page / total pages display
        if ($('.fb_product_cp').length > 0) {
            $('.fb_product_cp').text(pagination.current_page + ' / ' + pagination.total_pages);
        }

        // Update pagination buttons
        theme.filter.updatePaginationButtons();
    };

    /**
     * New method: Update pagination button states
     */
    theme.filter.updatePaginationButtons = function () {
        var pagination = theme.filter.pagination;
        var currentPage = pagination.current_page;
        var totalPages = pagination.total_pages;

        // Remove active class from all buttons
        $('.fb_counter').removeClass('bg-gray-700 text-white').addClass('hover:bg-light-grey');

        // Add active class to current page button
        $('.fb_counter[data-customid="' + currentPage + '"]')
            .addClass('bg-gray-700 text-white')
            .removeClass('hover:bg-light-grey');

        // Disable/enable prev/next buttons
        var $prevBtn = $('.fb_paginate[data-customid="prev"]');
        var $nextBtn = $('.fb_paginate[data-customid="next"]');

        if (currentPage <= 1) {
            $prevBtn.addClass('opacity-50 cursor-not-allowed');
        } else {
            $prevBtn.removeClass('opacity-50 cursor-not-allowed');
        }

        if (currentPage >= totalPages) {
            $nextBtn.addClass('opacity-50 cursor-not-allowed');
        } else {
            $nextBtn.removeClass('opacity-50 cursor-not-allowed');
        }
    };

    /**
     * Override _paginate to use URL-based pagination
     */
    theme.filter._paginate = function () {
        // This method is no longer used for client-side pagination
        // Instead, we navigate to the new page URL
        console.warn('_paginate called - use goToPage instead');
    };

    // Initialize on DOM ready
    $(document).ready(function () {
        theme.debugging && console.info("%c[Enhanced Filter] ----- Ready", "color: #00ff00");
    });

})();
